import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/faqs/loading.js");
